export const UNKNOWN_ONBOARDING_API_ERROR_CODE = 999;

type OnboardingApiParameterError = {
  message: string;
  name: string;
}

export class OnboardingApiError extends Error {
  code?: number;
  error?: string;
  name = OnboardingApiError.name;
  parameters?: OnboardingApiParameterError[];
  statusCode?: number;
  traceId?: string;

  constructor ({
    code,
    error,
    message,
    parameters,
    statusCode,
    traceId,
  }: Partial<OnboardingApiError>) {
    super(message);

    this.traceId = traceId;
    this.statusCode = statusCode;
    this.code = code;
    this.error = error;
    this.parameters = parameters;
  }
}
